"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));

var _Title = _interopRequireDefault(require("../../Title"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};
/* eslint-disable no-param-reassign */

/* eslint-disable @typescript-eslint/prefer-optional-chain */

/* eslint-disable @typescript-eslint/naming-convention */


var BuyNowComponent = function BuyNowComponent(props) {
  var flexTitle = props.flexTitle,
      desc = props.desc,
      flexSmallTitle = props.flexSmallTitle,
      mergeComponentStatus = props.mergeComponentStatus,
      configuration = props.configuration,
      style = props.style,
      onCallback = props.onCallback,
      layoutMode = props.layoutMode;
  var layoutNum = layoutMode ? 3 : 4;
  var compatibleArr = configuration && configuration.length % layoutNum ? __spreadArrays(configuration, new Array(layoutNum - configuration.length % layoutNum).fill({
    supplement: true
  })) : configuration;
  var buyCon = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-buy-now-default-container-bp2',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-buy-now-default-container__children'
  }, (flexTitle || desc || flexSmallTitle) && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-buy-now-default-container__children__container',
    ref: buyCon
  }, compatibleArr && compatibleArr.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        supplement = _a.supplement,
        duration = _a.duration,
        backgroundUrl = _a.backgroundUrl,
        text_list = _a.text_list,
        content = _a.content,
        but_txt = _a.but_txt,
        but_href = _a.but_href,
        extendProps = _a.extendProps;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-list', {
        'flex-buy-now-default-container__children__container__list__container--mobile': supplement
      }),
      key: index,
      style: layoutMode ? {
        minWidth: '30%',
        maxWidth: '33%'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list__container', {// 'flex-buy-now-default-container__children__container__list__container--mobile': supplement
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-buy-now-default-container__children__container__list'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list2', {
        'layout-three': layoutMode
      }),
      style: {
        backgroundImage: "url(" + backgroundUrl + ")"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__head'
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: but_href
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _classnames["default"])('list__title', {
        'layout-three': layoutMode
      })
    }, ' ', title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__description', {
        list__description_three: layoutMode
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      dangerouslySetInnerHTML: {
        __html: content || ''
      }
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__botton', {
        'layout-three': layoutMode
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__text', {
        'layout-three': layoutMode
      })
    }, text_list && text_list.map(function (item, index) {
      var _a = item || {},
          title = _a.title,
          text = _a.text;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list',
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list_title'
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'list__text_list_text'
      }, text));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__duration', {
        'layout-three': layoutMode
      })
    }, duration), onCallback ? /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('list__a', {
        'layout-three': layoutMode
      }),
      onClick: function onClick() {
        onCallback(item);
      }
    }, extendProps || {}), but_txt) : /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: but_href
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__a'
    }, but_txt)))))));
  }))));
};

var BuyProduct2 = function BuyProduct2(props) {
  var paddingTopNum = props.paddingTopNum,
      paddingBottomNum = props.paddingBottomNum,
      flexTitle = props.flexTitle,
      style = props.style,
      isFooterPart = props.isFooterPart,
      isCombination = props.isCombination;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(BuyNowComponent, __assign({}, props)));
};

var _default = BuyProduct2;
exports["default"] = _default;